import React from 'react';
import classes from './RegistrationBenefits.module.scss';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';

const RegistrationBenefits: React.FC = () => {
  return (
    <ul className={classes.tickList}>
      <li>
        <Heading className={classes.heading}>Extra money in your spare time</Heading>
        <Txt component="p">
          Take surveys about your favourite products and get rewarded. All you need is your mobile
          phone and an internet connection.
        </Txt>
      </li>
      <li>
        <Heading className={classes.heading}>Quick and easy</Heading>
        <Txt component="p">
          Anyone can turn their opinions into extra income with Mobiworkx surveys. No experience or
          qualifications needed.
        </Txt>
      </li>
      <li>
        <Heading className={classes.heading}>Sign up, take surveys, get rewarded</Heading>
        <Txt component="p">
          Join now in just a couple of minutes and see how easy it is to supplement your income with
          online surveys.
        </Txt>
      </li>
    </ul>
  );
};

export default RegistrationBenefits;
